import { render, staticRenderFns } from "./NewButton.vue?vue&type=template&id=5ba1a3d2&scoped=true"
import script from "./NewButton.vue?vue&type=script&lang=js"
export * from "./NewButton.vue?vue&type=script&lang=js"
import style0 from "./NewButton.vue?vue&type=style&index=0&id=5ba1a3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba1a3d2",
  null
  
)

export default component.exports